export default function Navbar({ user, handleLogout, setShowPopup, isMenuOpen, setIsMenuOpen }) { 
    return (
        <header>
            <h2 className="logo">Web personal</h2>
            
            {/* Nút Hamburger cho Mobile */}
            <div className="menu-icon" onClick={() => setIsMenuOpen(!isMenuOpen)}>
            <ion-icon name={isMenuOpen ? "close" : "menu"}></ion-icon>
            </div>
    
            <nav className={`navigation ${isMenuOpen ? 'mobile-active' : ''}`}>
            <a href="#" onClick={() => setIsMenuOpen(false)}>Home</a>
            <a href="#" onClick={() => setIsMenuOpen(false)}>About</a>
            <a href="#" onClick={() => setIsMenuOpen(false)}>Services</a>
            <a href="#" onClick={() => setIsMenuOpen(false)}>Contact</a>
            
            {user ? (
                <div className="user-nav">
                <span className="user-name">Chào, {user.displayName || user.email.split('@')[0]}</span>
                <button className="btnLogout-popup" onClick={() => { handleLogout(); setIsMenuOpen(false); }} style={{background: '#ff4b2b'}}>Logout</button>
                </div>
            ) : (
                <button className="btnLogin-popup" onClick={() => { setShowPopup(true); setIsMenuOpen(false); }}>Login</button>
            )}
            </nav>
        </header>
    );
}